module.exports = __webpack_public_path__ + "static/media/header-background.d5d94e82.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Header/assets/header-background.jpg
// module id = 26
// module chunks = 0